
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground, PropsTable } from "docz";
import Avatar from "../shared/components/Avatar.js";
import "../shared/css/index.css";

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"avatar"}}>{`Avatar`}</MDXTag>
<Playground __position={0} __code={'<Avatar alt=\"Foto de perfil\" />'} __scope={{props: this ? this.props : props,Avatar}}>
  <Avatar alt="Foto de perfil"/>
</Playground>
<PropsTable of={Avatar} />
<MDXTag name="h2" components={components} props={{"id":"custom-image"}}>{`Custom image`}</MDXTag>
<Playground __position={2} __code={'<Avatar\n  src=\"https://avatars0.githubusercontent.com/u/8336082?s=460&v=4\"\n  alt=\"Foto de perfil\"\n/>\n<br />\n<Avatar\n  src=\"https://avatars0.githubusercontent.com/u/8336082?s=460&v=4\"\n  alt=\"Foto de perfil\"\n  size={50}\n/>\n<br />\n<Avatar\n  src=\"https://avatars0.githubusercontent.com/u/8336082?s=460&v=4\"\n  alt=\"Foto de perfil\"\n  size={100}\n/>'} __scope={{props: this ? this.props : props,Avatar}}>
  <Avatar src="https://avatars0.githubusercontent.com/u/8336082?s=460&v=4" alt="Foto de perfil"/>
  <br />
  <Avatar src="https://avatars0.githubusercontent.com/u/8336082?s=460&v=4" alt="Foto de perfil" size={50}/>
  <br />
  <Avatar src="https://avatars0.githubusercontent.com/u/8336082?s=460&v=4" alt="Foto de perfil" size={100}/>
</Playground>
           </MDXTag>
  }
}
  